import { Popover, Box, Tag } from '@nimbus-ds/components';
import { ChevronDownIcon, ChevronUpIcon } from '@nimbus-ds/icons';
import { StatesType } from '../types';

interface StatesPopoverProps {
  readonly states: StatesType[];
  readonly statesName: (state: StatesType) => string;
  readonly isShowPopover: boolean;
}
function StatesPopover({
  states,
  statesName,
  isShowPopover,
}: StatesPopoverProps) {
  return (
    <Popover
      content={
        <Box gap="1" display="flex" flexDirection="row" flexWrap="wrap">
          {states.map((state) => (
            <Tag key={state}>{statesName(state)}</Tag>
          ))}
        </Box>
      }
      position="bottom"
      arrow={false}
      zIndex="900"
    >
      {isShowPopover ? <ChevronUpIcon /> : <ChevronDownIcon />}
    </Popover>
  );
}

export default StatesPopover;
